import {AreasList} from "./AreasList";
import {AreasEdit} from "./AreasEdit";
import {AreasCreate} from "./AreaCreate";

export default {
    list: AreasList,
    create: AreasCreate,
    edit: AreasEdit
};
